module.exports = __webpack_public_path__ + "static/media/6_NL.87c5e043.mp3";